<template>
  <div class="flexwrap">
    <span>Besoin d'aide, une question, un retour ? Nous sommes disponibles presque 24h / 24.</span>
    <component id="landingPageTeamBody" :is="isMobile?'carousel':'div'"
               :perPage="1" :minSwipeDistance="50" :paginationEnabled="true" :touchDrag="true" :autoplay="false" :loop="true"
               :autoplayTimeout="3500" paginationActiveColor="var(--goalBackgroundColor2)" paginationColor="#ffffff88" :paginationPadding="5" >
      <component class="equipe" :is="isMobile?'slide':'div'">
        <h2 style="grid-column: 1/3">Equipe dirigeante</h2>
        
        <img class="profile_pic" src="@/assets/landing_page/romain.webp">
        <div class="role">
          <h3>Romain Destenay</h3>
          Co-fondateur
          <br>Développeur Full-Stack
        </div>
        <img class="profile_pic" src="@/assets/landing_page/jeremy.webp">
        <div class="role">
          <h3>Jeremy Batbedat</h3>
          Co-fondateur
          <br>Développeur Front-End
        </div>
        <img class="profile_pic" src="@/assets/landing_page/fanny.webp">
      </img>
        <div class="role">
          <h3>Fanny Destenay</h3>
          Co-fondatrice
          <br>Community manager et communication
        </div>
      </component>
      <component class="equipe"  :is="isMobile?'slide':'div'">
        <h2 style="grid-column: 1/3">Conseil pédagogique</h2>
        <img class="profile_pic" src="@/assets/landing_page/amelie.webp">
        <div class="role">
          <h3>Amélie Hecky</h3>
          Professeur de français
        </div>
        <img class="profile_pic" src="@/assets/landing_page/estelle.webp">
        
        <div class="role">
          <h3>Estelle De Goër</h3>
          Agrégée de lettres modernes
        </div>
      </component>
    </component>
  </div>
</template>

<script>
import {Carousel, Slide} from "vue-carousel";
import {mapGetters} from "vuex";

export default {
  name: "landingPageTeam",
  components: {
    Carousel,
    Slide,
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>
#landingPageTeamBody{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1vw;
}

.equipe{
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 1vw;
  align-items: flex-start;
  justify-items: flex-start;
  padding-top: 1vw;
  align-content: flex-start;
}
.role{
  padding-top: 1vw;
}
.role>h3{
  font-weight: bold;
}

.profile_pic{
  width: 8vw;
  height: 8vw;
  border-radius: 2vw;
  background-size: cover;
}

@media screen and (max-device-width: 767px) {
  #landingPageTeamBody{
    height: fit-content;
    width: 100vw;
    display: block;
    justify-self: center;
    font-size: 1em;
    transform: translateX(-8vw);
  }
  .equipe{
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 4vw;
    align-items: flex-start;
    justify-items: flex-start;
    padding-top: 4vw;
    align-content: flex-start;
    width: 84vw;
    max-width: 84vw;
    margin: 0 8vw 0 8vw;
  }
  .role{
    padding-top: 4vw;
  }
  .role>h3{
    font-weight: bold;
  }

  .profile_pic{
    width: 28vw;
    height: 28vw;
    border-radius: 6vw;
    background-size: cover;
  }
}

</style>